export default __webpack_public_path__ + "static/media/SpaceX.3b60d1d7.md";